module.exports = __webpack_public_path__ + "static/img/pay_false.62aa0a64.png";